<div [formGroup]="group">
  <mat-form-field appearance="outline" [formGroup]="group" class="basic-input-field" [ngClass]="config.class"
    (focusout)="checkvalue()" tabindex="-1">
    <mat-label class="select-label">{{config.label}}</mat-label>
    <mat-chip-grid #chipList ngDefaultControl [formControlName]="config.name" [value]="selectedOptions">
      @for (option of selectedOptions; track option; let i = $index) {
      <mat-chip-row [selectable]="selectable" [removable]="removable" (removed)="remove(i)" (touchend)="tapEvent(i)">
        {{option}}
      </mat-chip-row>
      }
    <input
      matInput
      #autoCompleteInput
      [matAutocomplete]="auto"
      [attr.name]="config.name"
      [matChipInputFor]="chipList"
      [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
      [matChipInputAddOnBlur]="addOnBlur"
      (matChipInputTokenEnd)="add($event)"
      (input)="inputEmiter($event)"
      (keydown)="removeLast($event)"
      tabindex="-1"
      id="{{config.id}}">
    </mat-chip-grid>
    <mat-autocomplete  #auto="matAutocomplete" #autoCompleteInput (optionSelected)="selected($event)">
      @for (autocompleteOption of autocompleteOptions; track autocompleteOption) {
        <mat-option id="{{autocompleteOption.name}}">
          <span [innerHTML]="autocompleteOption.name | highlight: toHighlight"></span>
        </mat-option>
      }
    </mat-autocomplete>
    @if (group.controls[FormControlName].hasError('minlength') && config.showErrorText) {
      <mat-error>
        {{ 'common.minLength' | translate }}
      </mat-error>
    }
    @if (group.controls[FormControlName].hasError('required') && group.controls[FormControlName].touched && config.showErrorText) {
      <mat-error>
        {{ 'common.autoComplteError' | translate }}
      </mat-error>
    }

  </mat-form-field>



</div>
